module.exports = __webpack_public_path__ + "static/media/cash-register-sound.61a42245.mp3";